<template lang="html">

<div class="upload-img">
      <el-upload
        class="upload-demo"
        ref="upload"
        accept="image/*"
        :on-success="handleSuccess"
        :before-upload="beforeUpload"
        :file-list="fileList"
        list-type="picture-card"
        :limit="limit"
        :on-exceed="handleExeccd"
        :on-remove="handleRemove">
        <el-button size="small" type="primary">
             <span>点击上传</span>
        </el-button>
        <div slot="tip" v-show="limit>1" class="el-upload__tip">{{fileStore.length}}/{{limit}}{{tips}}</div>
      </el-upload>
</div>

</template>

<script>
import { getToken } from '@/utils/auth';
import { getFileToken,getViewKey,detFile } from '@/api/account';
export default {
    props:['files','listType','limit','preKey','tips'],
    data(){
        return{
            fileList: [],
            postDat:'',

            viewDat:'',
            fileMap:{},
            fileStore:[]
        }
    },
    watch:{
        files:function(e){
            this.filesSet(e);
        }
    },
    methods:{
        filesSet:function(e){
            console.log(e);
            if(this.fileList.length === 0 && e && this.viewDat){
               var files = e.split(',');
               var urlArr = [];
               files.forEach(item => {
                   if(item){
                        urlArr.push({
                            id:item,
                            url:this.viewDat.imagePreUrl + '/id/' + item + '/token/' + this.viewDat.token
                        });
                   }
                   
               })
               this.fileList = urlArr;
               this.fileStore = urlArr;
            }
        },
        beforeUpload:function(file){
            var isImage = file.type.split('\/')[0] === 'image';

            var isLt100M = file.size / 1024 / 1024 <= 2;
            if (!isLt100M) {
                this.$message.error('文件大小不能超过 2 MB!');
            }

            if(!isImage){
                this.$message.error('只能上传格式为 jpg/jpeg/png/pdf 的文件');
            }

            if(isLt100M && isImage){
               return true;
            }
        },

        handleSuccess:function(res,file,fileList){
            console.log(fileList);
            var newMap = {};
            fileList.forEach(item => {
                if(item.raw&&item.raw.id){
                    item.id=item.raw.id;
                }
                if(item.id){
                    newMap[item.uid] = item.id;
                }else if(this.fileMap[item.uid]){
                    newMap[item.uid] = this.fileMap[item.uid];
                }
            });
            newMap[file.uid] = this.postDat.key;
            this.fileMap = newMap;
            this.flieStoreSet(fileList);
        },

        handleRemove:function(file,fileList){
            console.log(file,fileList,this.fileMap);
            detFile({id:file.id ,fileType:1});
            this.flieStoreSet(fileList);
        },

        handleExeccd:function(){
            this.$message.error('上传文件已达上限！');
        },

        flieStoreSet:function(fileList){
            console.log(fileList);
            var vues= this;
            this.fileStore = [];
            var newArr = [];
            fileList.forEach(item => {
                var file = {
                    name:item.uid,
                    id:item.id,
                }
                newArr.push(file.id);
                vues.fileStore.push(file);
            })
            this.$emit('fileChange',{
                data:newArr.join(','),
                preKey:this.preKey
            });
        }

    },
    mounted:function(){
             let vm = this;
             var userInfo = this.$store.getters.userInfo;

             this.$refs.upload.$refs['upload-inner'].uploadFiles = function(files){
                 let svm = vm.$refs.upload.$refs['upload-inner'];
                 if (svm.limit && svm.fileList.length + files.length > svm.limit) {
                   svm.onExceed && svm.onExceed(files, svm.fileList);
                   return;
                 }
                 let postFiles = Array.prototype.slice.call(files);
                 if (!svm.multiple) { postFiles = postFiles.slice(0, 1); }
                 if (postFiles.length === 0) { return; }


                 getFileToken({userId:userInfo.userId,fileType:1}).then(res => {
                      vm.postDat = res;
                      postFiles.forEach(rawFile => {
                          rawFile.id=res.key;
                        svm.onStart(rawFile);
                        rawFile.postUrl = vm.postDat.fileUploadUrl;
                        if (svm.autoUpload) svm.upload(rawFile);
                      });
                 });
             };

             this.$refs.upload.$refs['upload-inner'].post = function(rawFile){
                  const { uid } = rawFile;
                  let svm = vm.$refs.upload.$refs['upload-inner'];
                  let s = {
                      token:getToken(),
                      key:vm.postDat.key,
                      fileSize:rawFile.size
                  };
                      const options = {
                        headers: svm.headers,
                        withCredentials: this.withCredentials,
                        file: rawFile,
                        data: s,
                        filename: svm.name,
                        action: rawFile.postUrl,
                        onProgress: e => {
                          svm.onProgress(e, rawFile);
                        },
                        onSuccess: res => {
                          svm.onSuccess(res, rawFile);
                          delete this.reqs[uid];
                        },
                        onError: err => {
                          svm.onError(err, rawFile);
                          delete this.reqs[uid];
                        }
                      };
                      const req = svm.httpRequest(options);
                      svm.reqs[uid] = req;
                      if (req && req.then) {
                        req.then(options.onSuccess, options.onError);
                      }
             };
    },
    created:function(){

        getViewKey().then(res => {
            this.viewDat = {
                imagePreUrl:res.imagePreUrl,
                token:res.token
            };
            this.filesSet(this.files);
        })
    }
}
</script>

<style lang="css" scoped>

.upload-img{
    padding-top: 2px;
}

.el-upload__tip{
    display: inline-block;
    margin-left: 12px;
}

.imgCard{
    width: 120px;
    height: 120px;
    border-radius: 6px;
    border:1px solid #F1F1F1;
    margin-top: 12px;
}

.imgCard .pgress{
   margin: 15px;
}

</style>



// WEBPACK FOOTER //
// imgUpload.vue?55f4029c